export function initProductHeaderShareContainer() {
  initCopyHandler()
  initShareContainerOpener()
  pushMailInYaShare()
}

function initCopyHandler() {
  const containerEl = document.querySelector('.js-select-text')
  const textEl = document.querySelector('.js-product-copy-text')
  const buttonEl = document.querySelector('.js-product-copy-button')

  if (!buttonEl) return

  buttonEl.addEventListener('click', copyText)

  containerEl.addEventListener('click', copyText)

  function copyText() {
    textEl.select()
    textEl.setSelectionRange(0, 99999) /*For mobile devices*/
    document.execCommand('copy')
  }
}

function initShareContainerOpener() {
  const buttonEl = document.querySelector('.js-product-share-button')
  const shareContainerEl = document.querySelector('.js-product-share-content')

  if (!buttonEl) return

  buttonEl.addEventListener('click', () => shareContainerEl.classList.toggle('active'))
  document.addEventListener('click', e => {
    const isShareContainer = e.target.closest('.js-product-share-container') !== null

    if (isShareContainer) return

    shareContainerEl.classList.remove('active')
  })
}

function pushMailInYaShare() {
  const mailEl = document.querySelector('.js-push-to-ya-share-mail')
  const liEl = document.createElement('li')
  const yaShareListEl = document.querySelector('.ya-share2__list')

  if (!mailEl) return

  liEl.classList.add('ya-share2__item')
  liEl.appendChild(mailEl.cloneNode(true))
  mailEl.remove()
  yaShareListEl.appendChild(liEl)
}
